var urlParams = new URLSearchParams( window.location.search );

function updateUrl() {
	let oldURL = new URL( window.location );
	if ( urlParams.has( 'page' ) ) {
		urlParams.delete( 'page' );
	} else {
		let path = oldURL.pathname.split( '/' ).filter( ( n ) => n );

		if ( path && path.length >= 2 && path[ path.length - 2 ] === 'page' ) {
			path = path.slice( 0, -2 ).join( '/' );
			path = path ? '/' + path + '/' : '/';
			oldURL.pathname = path;
		}
	}
	oldURL.search = urlParams;
	window.location = oldURL;
}

function updateFilterBlock( filterBlock ) {
	var myTimer = null;
	var myTimeout = 2000;

	if ( filterBlock.hasAttribute( 'data-attribute-timeout' ) ) {
		myTimeout = parseInt(
			filterBlock.getAttribute( 'data-attribute-timeout' )
		);
	}

	const attributeBlocks = filterBlock.querySelectorAll(
		':scope > div.ims-filter-attribute'
	);

	for ( let i = 0; i < attributeBlocks.length; ++i ) {
		updateFilter( attributeBlocks[ i ] );
	}

	function updateFilter( blockNode ) {
		if ( ! blockNode.hasAttribute( 'data-attribute-id' ) ) {
			return;
		}
		const filterId = blockNode.getAttribute( 'data-attribute-id' );

		const terms = blockNode.querySelectorAll(
			':scope > ul > li:not(.see-more)'
		);

		const seeMoreNode = blockNode.querySelector(
			':scope > ul > li.ims-filter-attribute-show-more'
		);
		const seeLessNode = blockNode.querySelector(
			':scope > ul > li.ims-filter-attribute-show-less'
		);
		let seeMore = false;

		const filterMulti = blockNode.hasAttribute( 'data-attribute-multi' )
			? blockNode.getAttribute( 'data-attribute-multi' )
			: 'multi';

		const filterCondition = blockNode.hasAttribute(
			'data-attribute-condition'
		)
			? blockNode.getAttribute( 'data-attribute-condition' )
			: 'or';

		const allowMulti = filterMulti !== 'single';

		const queryFilter = urlParams.get( `filter_${ filterId }` );
		const queryCond = urlParams.get( `query_type_${ filterId }` );
		let activeFilters = queryFilter ? queryFilter.split( ',' ) : [];

		function showMoreToggle() {
			if ( seeMore ) {
				seeMoreNode.style.display = '';
				let nextItem = seeMoreNode.nextSibling;
				while ( nextItem ) {
					if ( nextItem.nodeType === Node.ELEMENT_NODE ) {
						nextItem.style.display = 'none';
					}
					nextItem = nextItem.nextSibling;
				}
				seeMore = false;
			} else {
				seeMoreNode.style.display = 'none';
				let nextItem = seeMoreNode.nextSibling;
				while ( nextItem ) {
					if ( nextItem.nodeType === Node.ELEMENT_NODE ) {
						nextItem.style.display = '';
					}
					nextItem = nextItem.nextSibling;
				}
				seeMore = true;
			}
		}

		if ( seeMoreNode ) {
			seeMoreNode.addEventListener( 'click', function () {
				showMoreToggle();
			} );
			seeLessNode.addEventListener( 'click', function () {
				showMoreToggle();
			} );
		}
		function updateQuery() {
			if ( ! activeFilters ) {
				return;
			}

			// const unique = activeFilters.filter((value, index, array) => array.indexOf(value) === index);
			const unique = [ ...new Set( activeFilters ) ];

			if ( unique.length ) {
				if ( queryCond !== filterCondition ) {
					urlParams.set(
						`query_type_${ filterId }`,
						filterCondition
					);
				}
				urlParams.set( `filter_${ filterId }`, unique.join( ',' ) );
			} else {
				urlParams.delete( `query_type_${ filterId }` );
				urlParams.delete( `filter_${ filterId }` );
			}
			urlParams.sort();
		}

		function connectTerm( termItem ) {
			if ( ! termItem.hasAttribute( 'data-attribute-value' ) ) {
				return;
			}

			const inputField = termItem.querySelector( ':scope input' );

			if ( ! inputField ) {
				return;
			}

			const attributeValue = termItem.getAttribute(
				'data-attribute-value'
			);

			inputField.addEventListener( 'click', function () {
				if ( myTimer != null ) {
					clearTimeout( myTimer );
					myTimer = null;
				}

				if ( inputField.checked ) {
					activeFilters.push( attributeValue );

					if ( ! allowMulti ) {
						for ( let i = 0; i < terms.length; ++i ) {
							if ( terms[ i ] !== termItem ) {
								const field =
									terms[ i ].querySelector( ':scope input' );
								if ( field ) {
									field.disabled = true;
								}
							}
						}
					}
				} else {
					activeFilters = activeFilters.filter(
						( value ) => value != attributeValue
					);
					if ( ! allowMulti && activeFilters.length === 0 ) {
						for ( let i = 0; i < terms.length; ++i ) {
							const field =
								terms[ i ].querySelector( ':scope input' );
							if ( field ) {
								field.disabled = false;
							}
						}
					}
				}

				updateQuery();

				if (
					window.location.search.toString() !== urlParams.toString()
				) {
					myTimer = setTimeout( updateUrl, 2000 );
				}
			} );
		}

		for ( let i = 0; i < terms.length; ++i ) {
			connectTerm( terms[ i ] );
		}
	}
}

( function () {
	document.addEventListener(
		'DOMContentLoaded',
		function () {
			const filterBlocks = document.querySelectorAll(
				'.wp-block-ims-wc-filter-by-attribute-filter'
			);

			for ( let i = 0; i < filterBlocks.length; ++i ) {
				updateFilterBlock( filterBlocks[ i ] );
			}
		},
		false
	);
} )();
